// =====================================================================
// Assessment Center — Instructor Login.
// Fields: Email, Password.
// =====================================================================
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthShell from "./AuthShell";
import { Button, Field, Input } from "../../shared/components/ui";
import { useAuth } from "../../shared/auth/AuthContext";

export default function InstructorLoginPage() {
  const { instructorLogin } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await instructorLogin({ email, password });
      navigate("/instructor/assessment-center");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Couldn't sign you in.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthShell title="Instructor Login" subtitle="Sign in to manage exams and grading.">
      <form onSubmit={handleSubmit} className="space-y-4">
        <Field label="Email" required>
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@school.edu" required />
        </Field>
        <Field label="Password" required>
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </Field>

        {error && <p className="text-sm text-red-600">{error}</p>}

        <Button type="submit" className="w-full" disabled={submitting}>
          {submitting ? "Signing in…" : "Login"}
        </Button>
      </form>

      <div className="mt-6 border-t border-border-soft pt-5 text-center">
        <p className="text-sm text-slate-500">New instructor?</p>
        <Link to="/register/instructor">
          <Button variant="secondary" className="mt-3 w-full">
            Register as Instructor
          </Button>
        </Link>
      </div>
    </AuthShell>
  );
}
